<template>
  <div class="home">
    <a-row :gutter="[8, 8]" justify="space-between" style="height: 65vh; max-height: 500px; align-items: stretch;"
           type="flex">
      <a-col :lg="14" :md="14" :sm="24" :xl="8" :xs="24" :xxl="8" style="align-self: stretch;">
        <a-card style="display: flex; align-items: center; height: 100%;">
          <h1 style="font-size: 3em">Wylogowano!</h1>
          <p>Teraz możesz udać się na stronę główną <span class="no-orphan">lub z gracją</span> zamknąć
            zakładkę
            <span class="no-orphan">w
                            przeglądarce</span>.
          </p>
          <p>Do następnego razu!</p>
          <a-button type="primary" @click="() => goTo('Home')">
            Idź na główną
          </a-button>
          <a-button style="margin-left: 8px;" type="default" @click="() => goTo('Login')">
            Zaloguj ponownie
          </a-button>
        </a-card>
      </a-col>

      <a-col :lg="10" :md="10" :sm="0" :xl="16" :xs="0" :xxl="16" style="align-self: stretch;">
        <a-card class="header" style=" height: 100%;">
          <a-row :gutter="[16, 16]" align="middle" justify="center" type="flex">
            <a-col :span="24">
              <VueLottiePlayer :animationData="require('@/assets/logout.json')" :width="'auto'" loop
                               name="Server Animation"
                               style="height: 65vh; max-height: 500px;"/>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Logout",
  components: {
    VueLottiePlayer
  },
  data() {
    return {};
  },
  mounted() {
    this.$emit("loadedView");
  },
  methods: {
    goTo: function (name) {
      this.$router.push({name: name});
    },
  }
};
</script>

<style scoped>
.header {
  background: rgb(0, 33, 61);
  background: linear-gradient(120deg, rgba(0, 22, 40, 1) 5%, rgba(25, 144, 255, 1) 200%);
  padding: 2vh 5vw;
}

@media screen and (min-width: 992px) {
  .header {
    background: rgb(0, 33, 61);
    background: linear-gradient(120deg, rgba(0, 22, 40, 1) 10%, rgba(25, 144, 255, 1) 120%);
    padding: 1vh 10vw;
  }
}

.header-text {
  font-size: 3em;
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1),
  4px 4px 0px rgba(0, 0, 75, 1),
  5px 5px 0px rgba(0, 0, 75, 1);
}

.sub-header-text {
  color: #ffffff;
  text-shadow: 1px 1px 0px rgba(0, 0, 75, 1),
  2px 2px 0px rgba(0, 0, 75, 1),
  3px 3px 0px rgba(0, 0, 75, 1);
}
</style>